import { render, staticRenderFns } from "./SvgPopup.vue?vue&type=template&id=55355335&scoped=true"
import script from "./SvgPopup.vue?vue&type=script&lang=ts"
export * from "./SvgPopup.vue?vue&type=script&lang=ts"
import style0 from "./SvgPopup.vue?vue&type=style&index=0&id=55355335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55355335",
  null
  
)

export default component.exports